module.exports = __webpack_public_path__ + "static/media/reloj.dcae3b70.svg";